export const countryOptions = [
    { value: "unitedStates", label: "United States" },
    { value: "canada", label: "Canada" },
    { value: "unitedKingdom", label: "United Kingdom" },
    { value: "australia", label: "Australia" },
    { value: "germany", label: "Germany" },
    { value: "france", label: "France" },
    { value: "spain", label: "Spain" },
    { value: "italy", label: "Italy" },
    { value: "netherlands", label: "Netherlands" },
    { value: "sweden", label: "Sweden" },
    { value: "norway", label: "Norway" },
    { value: "denmark", label: "Denmark" },
    { value: "finland", label: "Finland" },
    { value: "ireland", label: "Ireland" },
    { value: "newZealand", label: "New Zealand" },
    { value: "singapore", label: "Singapore" },
    { value: "malaysia", label: "Malaysia" },
    { value: "japan", label: "Japan" },
    { value: "southKorea", label: "South Korea" },
    { value: "india", label: "India" },
];
const getLabelForValue = (value, array) => {
    const item = array.find(i => i.value == value);
    return item?.label || value;
};

const userFieldsData = {
    countryOptions,
    getLabelForValue
}
export default userFieldsData;